exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-text-fast-style-card-2ERab{width:40px;height:40px;display:flex;flex-flow:column wrap;align-items:center;justify-content:center;background-size:cover;border-radius:4px;box-sizing:border-box}", ""]);

// Exports
exports.locals = {
	"text-fast-style-card": "index-text-fast-style-card-2ERab"
};